import React, { useState, useEffect, useRef } from "react"
import { useDispatch } from "react-redux"
import Input from "../Input/Input"
import { searchCoApplicants } from "../../features/coApplicants/coApplicants"

const CoApplicantSearch = ({ company, onSelect }) => {
  const dispatch = useDispatch()
  const [query, setQuery] = useState('')
  const [results, setResults] = useState([])
  const [showDropdown, setShowDropdown] = useState(false)
  const debounceRef = useRef(null)
  const wrapperRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowDropdown(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleSearch = (value) => {
    setQuery(value)
    if (debounceRef.current) clearTimeout(debounceRef.current)

    if (value.length < 2) {
      setResults([])
      setShowDropdown(false)
      return
    }

    debounceRef.current = setTimeout(async () => {
      const response = await dispatch(searchCoApplicants({ query: value, company }))
      const data = Array.isArray(response?.payload) ? response.payload : response?.payload?.data || []
      setResults(data)
      setShowDropdown(true)
    }, 300)
  }

  useEffect(() => {
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current)
    }
  }, [])

  const handleSelect = (coApplicant) => {
    setQuery(`${coApplicant.firstName} ${coApplicant.lastName}`)
    setShowDropdown(false)
    setResults([])
    onSelect(coApplicant)
  }

  return (
    <div ref={wrapperRef} className="relative">
      <Input
        label="Search co-applicant"
        placeholder="Enter name or email..."
        value={query}
        onChange={(e) => handleSearch(e.target.value)}
      />
      {showDropdown && results.length > 0 && (
        <div className="absolute z-50 w-full mt-1 bg-surface border border-divider rounded-lg shadow-lg max-h-[200px] overflow-y-auto">
          {results.map((item) => (
            <div
              key={item._id}
              className="px-4 py-3 cursor-pointer hover:bg-background transition-colors"
              onClick={() => handleSelect(item)}
            >
              <div className="font-semibold text-[14px]">
                {item.firstName} {item.lastName}
              </div>
              <div className="text-[12px] text-text-secondary">
                {item.email}
              </div>
            </div>
          ))}
        </div>
      )}
      {showDropdown && results.length === 0 && query.length >= 2 && (
        <div className="absolute z-50 w-full mt-1 bg-surface border border-divider rounded-lg shadow-lg">
          <div className="px-4 py-3 text-[14px] text-text-secondary">
            No co-applicants found
          </div>
        </div>
      )}
    </div>
  )
}

export default CoApplicantSearch
